var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "breadcrumbs-navigation"
  }, [_c('ul', {
    staticClass: "br_crumb-nav"
  }, [_c('li', {
    staticClass: "first"
  }, [_c('router-link', {
    attrs: {
      "to": "/index"
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', {
    staticClass: "last"
  }, [_c('router-link', {
    staticClass: "page_link",
    attrs: {
      "to": "/portfolio"
    }
  }, [_vm._v("Portfolio")])], 1)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bc932fde","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/extract-loader/lib/extractLoader.js!./node_modules/html-loader?{"interpolate":true,"attrs":[":url","link:href","source:src"]}!./src/components/breadcrumbs-navigation/breadcrumbs-navigation.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-bc932fde","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/extract-loader/lib/extractLoader.js!./node_modules/html-loader/index.js?{"interpolate":true,"attrs":[":url","link:href","source:src"]}!./src/components/breadcrumbs-navigation/breadcrumbs-navigation.vue
// module chunks = index